import React, { useState } from "react";
import "./cookies.css";
import ToggleButton from 'react-toggle-button';

export default function Cookies_content() {
  return (
    <div>
      <div className="accordion">
        {accordionData.map(({ id, title, content }) => (
          <Accordion id={id} title={title} content={content}/>
        ))}
      </div>
    </div>
  );
}

const Accordion = ({ id, title, content  }) => {
  const [isActive, setIsActive] = useState(false);
  const [toggleActive, setToggleActive] = useState(localStorage.getItem("cookie" + id.toString()) != 'false' ? true: false);

  return (
    <div className="accordion-item">
      <div className="accordion-title">
        <div style={{whiteSpace: 'nowrap', width: '100%'}} onClick={() => setIsActive(!isActive)} >
          {isActive ? "-" : "+"} {title}
        </div>
        {title != 'คุกกี้ที่จำเป็น'
               ?<ToggleButton id={'cookie' + id.toString()} 
                              value={toggleActive} 
                              onToggle={(value) => {
                                setToggleActive(!value)
                                if(!value){
                                  localStorage.setItem('cookie' + id.toString(), 'true')
                                } else {
                                  // localStorage.removeItem('cookie' + id.toString())
                                  localStorage.setItem('cookie' + id.toString(), 'false')
                                }
                              }} />
               :<div style={{whiteSpace: 'nowrap', width: '35%'}} >เปิดใช้งานตลอดเวลา</div>}
        
      </div>
      {isActive && <div className="accordion-content">{content}</div>}
    </div>
  );
};

export const accordionData = [
  { 
    id: 1,
    title: "คุกกี้การใช้งาน",
    content: "คุกกี้เหล่านี้ช่วยในการทำงานของไซต์และการปรับแต่งไซต์ให้เหมาะกับผู้ใช้ เช่น วิดีโอและการสนทนาสด คุกกี้เหล่านั้นอาจได้รับการกำหนดโดยเราหรือผู้ให้บริการจากบริษัทอื่นที่เราได้เพิ่มบริการของพวกเขาลงในหน้าเพจ หากคุณไม่อนุญาตให้คุกกี้เหล่านี้ทำงาน ฟังก์ชันบางอย่างของไซต์อาจทำงานไม่ถูกต้อง"
  },
  {
    id: 2,
    title: "คุกกี้ประสิทธิภาพ",
    content: "คุกกี้เหล่านี้ช่วยเราในการนับจำนวนและที่มาของการเข้าชม เพื่อให้เราสามารถวัดและปรับปรุงประสิทธิภาพไซต์ของเราได้ นอกจากนี้ยังช่วยให้เราทราบว่าหน้าใดได้รับความนิยมมากที่สุดและน้อยที่สุด และทราบว่าผู้เยี่ยมชมเข้าดูส่วนใดบ้าง ข้อมูลทั้งหมดที่คุกกี้เหล่านี้จัดเก็บไว้จะถูกรวมไว้ด้วยกัน จึงทำให้ไม่สามารถระบุตัวตนได้ หากคุณไม่อนุญาตให้คุกกี้เหล่านี้ทำงาน เราจะไม่ทราบว่าคุณเข้าชมไซต์ของเราเมื่อใด"
  },
  {
    id: 3,
    title: "คุกกี้กำหนดเป้าหมาย",
    content: "คุกกี้เหล่านี้จะถูกกำหนดผ่านไซต์ของเราโดยพาร์ทเนอร์โฆษณาของเรา โดยบริษัทดังกล่าวอาจใช้คุกกี้เหล่านี้เพื่อสร้างโปรไฟล์เกี่ยวกับความสนใจของคุณ และแสดงโฆษณาที่คุณสนใจบนไซต์อื่นๆ คุกกี้เหล่านี้ทำงานโดยการระบุแต่ละเบราว์เซอร์และอุปกรณ์ของคุณ หากคุณไม่อนุญาตให้คุกกี้เหล่านี้ทำงาน คุณจะไม่เห็นโฆษณาที่คุณเป็นเป้าหมายบนเว็บไซต์ต่างๆ"
  },
  {
    id: 4,
    title: "คุกกี้ที่จำเป็น",
    content: "คุกกี้เหล่านี้จำเป็นสำหรับการทำงานกับเว็บไซต์ และไม่สามารถปิดการใช้งานในระบบของเราได้ และโดยปกติแล้ว คุกกี้เหล่านี้จะถูกกำหนดไว้เพื่อตอบสนองต่อการดำเนินการร้องขอบริการของคุณ เช่น การตั้งค่าความเป็นส่วนตัว การเข้าสู่ระบบ หรือการกรอกแบบฟอร์ม คุณสามารถกำหนดให้เบราว์เซอร์ของคุณทำการบล็อก หรือเตือนให้คุณทราบเกี่ยวกับคุกกี้เหล่านี้ แต่นั่นอาจทำให้บางส่วนของไซต์ไม่สามารถทำงานได้"
  }
];